export default __webpack_public_path__ + "static/media/under-construction.c0e20fcb.jpg";